import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';


export const useFetchScheduledRuns = ({ crId, crFlowId }) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const [scheduledRuns, setScheduledRuns] = useState([]);

  const {
    isLoading, isFetching, isError, isSuccess, data, refetch,
  } = useQuery(
    ['Cr-Scheduled-Runs', orgId, crFlowId, crId],
    async () => axiosInstance.get(flow(orgId).scheduledRuns(crId, crFlowId)),
    {
      onSuccess: () => dispatch(showAlert({ message: 'Flow Scheduled Runs fetched successfully.', type: 'success' })),
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (isSuccess) {
      setScheduledRuns(data.data.runDetails);
    }
  }, [isSuccess, data]);

  return {
    isLoading, isFetching, isError, isSuccess, data: scheduledRuns, refetch,
  };
};
